let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9eaLU")).then(() => parcelRequire('i31p0'));